define([
    "jquery",
    "underscore",
    "marionette",
    "forms/competition/ranking_form",
    "behaviors/form_errors_behavior",
    "backbone.syphon"
], function($, _, Marionette, Form, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui:{
            'submitBtn': '#ranking_search',
            'form': '#ranking_search_form',
            'mt4AccountNo': '#mt4_account_no',
            'tbody': '#ranking_search_tbody'
        },

        events:{
            'click @ui.submitBtn': 'submit',
            'submit @ui.form': 'submit'
        },

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        initialize: function(){
            this.bindUIElements();

            this.form = new Form();
        },

        submit: function(e){
            var that = this;
            if(e) e.preventDefault();

            var formData = Backbone.Syphon.serialize(this);

            this.form.set(formData);

            var errors = this.form.validate();

            if(_.size(errors) < 1){
                this.triggerMethod('hide:errors');
                that.ui.tbody.empty();
                $.ajax('/rest_competition/search_ranking',{
                    method: 'POST',
                    data: {
                        'group': window.group || '',
                        'mt4_account_no': this.ui.mt4AccountNo.val()
                    },
                    success: function(res, data){
                        that.ui.tbody.append("<tr><td>"+_.values(res).join('</td><td>')+"</td></tr>");
                    }
                });
            }else{
                this.triggerMethod('show:errors', errors);
            }
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/views/w/competition/ranking_view.js
// module id = 27
// module chunks = 0